export enum AlertBannerTypes {
  DANGER = 'danger',
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
  NOTIFICATION = 'notification',
  CALM = 'calm',
  NEUTRAL = 'neutral',
}
